(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7958],{

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-y2oqks-0"
})(["background:", ";margin-bottom:", ";"], function (props) {
  return props.withoutBackground ? props.theme.colors.white : props.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-y2oqks-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-y2oqks-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-y2oqks-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "ContactFormelements__TextArea",
  componentId: "sc-y2oqks-4"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(150));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-y2oqks-5"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-y2oqks-6"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-y2oqks-7"
})(["color:", ";padding-top:", ";display:block;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ContactFormTemplate = function ContactFormTemplate(_ref) {
  var withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var messageInputRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      hasNameError = _useState[0],
      setHasNameError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasEmailError = _useState2[0],
      setHasEmailError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasMessageError = _useState3[0],
      setMessageError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasSentError = _useState4[0],
      setHasSentError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isSent = _useState6[0],
      setIsSent = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      token = _useState7[0],
      setToken = _useState7[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _emailInputRef$curren, _emailInputRef$curren2, _messageInputRef$curr;

      var hasError, _nameInputRef$current2, _nameInputRef$current3, _emailInputRef$curren3, _phoneInputRef$curren, _phoneInputRef$curren2, _messageInputRef$curr2, _window, _window$fbq, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasEmailError(false);
              setMessageError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!((nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) === '')) {
                _context.next = 9;
                break;
              }

              setHasNameError(true);
              return _context.abrupt("return");

            case 9:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 12;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 12:
              if (!((messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr = messageInputRef.current) === null || _messageInputRef$curr === void 0 ? void 0 : _messageInputRef$curr.value) === '')) {
                _context.next = 15;
                break;
              }

              setMessageError(true);
              return _context.abrupt("return");

            case 15:
              if (!hasError) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              _context.prev = 17;
              setIsLoading(true);
              data = _objectSpread(_objectSpread(_objectSpread({}, (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) && {
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value
              }), {}, {
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value
              }, (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) && {
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value
              }), {}, {
                message: messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr2 = messageInputRef.current) === null || _messageInputRef$curr2 === void 0 ? void 0 : _messageInputRef$curr2.value,
                token: token
              });
              (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT) ? constants/* FBQ_EVENTS.LEAD */.PT.LEAD : constants/* FBQ_EVENTS.CONTACT */.PT.CONTACT);

              if (!router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT)) {
                _context.next = 26;
                break;
              }

              _context.next = 24;
              return contact_service/* contactApi.contactLease */.e.contactLease(data);

            case 24:
              _context.next = 28;
              break;

            case 26:
              _context.next = 28;
              return contact_service/* contactApi.contact */.e.contact(data);

            case 28:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              messageInputRef.current.value = '';
              _context.next = 39;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](17);
              setHasSentError(true);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 36]]);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var verifyRecaptchaCallback = (0,react.useCallback)(function (token) {
    setToken(token);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    withoutBackground: withoutBackground,
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            tagType: Title/* TitleTagTypes.H3 */.Z.H3,
            alignLeft: true,
            isBlack: true,
            children: t('contact.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('contact.form.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('contact.form.email.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.email.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('contact.form.phone.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
            ref: messageInputRef,
            placeholder: t('contact.form.message.placeholder'),
            className: "".concat(hasMessageError ? 'error' : '')
          }), hasMessageError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.message.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
            onVerify: verifyRecaptchaCallback
          }), (hasNameError || hasEmailError || hasMessageError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            marginTop: 30,
            onClick: handleClick,
            text: "Odeslat"
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (ContactFormTemplate);

/***/ }),

/***/ 47867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pronajem_uceben; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(57130);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/components/ContactForm/ContactForm.tsx + 1 modules
var ContactForm = __webpack_require__(26308);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/RentSupport/RentSuport.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentSuportelements__Wrapper",
  componentId: "sc-1itsy8t-0"
})(["display:flex;flex-direction:column;align-items:center;padding-top:", ";@media (min-width:", "px){flex-direction:row;gap:", ";align-items:unset;}"], (0,polished_esm/* rem */.hO)(70), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40));
var ContactPerson = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentSuportelements__ContactPerson",
  componentId: "sc-1itsy8t-1"
})(["width:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);border-radius:", ";padding:", ";margin:0 0 ", " 0;@media (min-width:", "px){margin:", " 0;}"], (0,polished_esm/* rem */.hO)(310), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(100));
var ContactPersonLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentSuportelements__ContactPersonLabel",
  componentId: "sc-1itsy8t-2"
})(["font-weight:", ";font-size:", ";font-family:", ";display:block;padding-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30));
var ContactPersonImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "RentSuportelements__ContactPersonImage",
  componentId: "sc-1itsy8t-3"
})(["width:", ";border-radius:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(260), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(20));
var ContactPersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentSuportelements__ContactPersonName",
  componentId: "sc-1itsy8t-4"
})(["font-weight:", ";font-size:", ";display:block;font-family:", ";padding-bottom:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(15));
var ContactPersonDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentSuportelements__ContactPersonDescription",
  componentId: "sc-1itsy8t-5"
})(["color:", ";display:block;padding-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(10));
var ContactPersonPhone = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "RentSuportelements__ContactPersonPhone",
  componentId: "sc-1itsy8t-6"
})(["color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/RentSupport/RentSupport.tsx









var RentSupportTemplate = function RentSupportTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
        withoutBackground: true
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactPerson, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonLabel, {
          children: t('classroomRent.support.person.label')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonImage, {
          src: (0,url_utils/* publicAssets */.VK)('/a_zizka.webp')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonName, {
          children: "Alexandra \u017Di\u017Eka"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonDescription, {
          dangerouslySetInnerHTML: {
            __html: t('classroomRent.support.person.description')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonPhone, {
          children: "+420 739 213 778"
        })]
      })]
    })
  });
};

/* harmony default export */ var RentSupport = (RentSupportTemplate);
;// CONCATENATED MODULE: ./src/pages/pronajem-uceben.tsx










var ClassroomRent = function ClassroomRent() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.classroomRent.title'),
      description: "",
      noindex: true,
      nofollow: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RentSupport, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var pronajem_uceben = (ClassroomRent);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var LEASE = 'pv/contact/lease-form';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var WITHDRAWAL = 'pv/contact/withdrawal';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  contactLease: function contactLease(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(LEASE, data);
  },
  withdrawal: function withdrawal(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(WITHDRAWAL, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 37397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pronajem-uceben",
      function () {
        return __webpack_require__(47867);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6506,9774,2888,179], function() { return __webpack_exec__(37397); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);